module.exports = __webpack_public_path__ + "img/grantRequest__close.4fc8e663.svg";